export function setCategories(state, categories) {
    state.categories = categories;
}

export function setCategory(state, category) {
    state.category = category;
}

